import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { BASEURL } from '../../../constants';
import toast from 'react-hot-toast';

export default function McqComponentPreview({contentObj}) {

    const [msq, setMcq] = useState(null)

    useEffect(() => {
      
        async function fetchOptionImageUrl(data) {
            const imagesPromiseArray = []
            const indexArray = []

            data.options.forEach(async (optionObject, index) => {
            
                if (optionObject.imageKey) {
                    const imagePromise = axios.get(`${BASEURL}/api/get-image`, {
                        params: {
                            imageId: optionObject.imageKey,
                            index: index
                        }
                    })
                    imagesPromiseArray.push(imagePromise)
                    indexArray.push(index)
                }

            })
          
            const promiseResponse = await Promise.all(imagesPromiseArray)
            promiseResponse.map((resObj, index) => {
                // { options : [ { image: url }]}
                const replaceIndex = indexArray[index]
                data.options[replaceIndex] = { ...data.options[replaceIndex], image: resObj.data.dataUrl }
            })
           
            setMcq(data);
        }
        if (contentObj.data) {

            fetchOptionImageUrl(contentObj.data)

        } else {

            setMcq({
                question: '',
                // options: ['', '', '', ''],
                options: [{ id: 1, text: "", image: null, imageKey: "" }, { id: 2, text: "", image: null, imageKey: "" }, { id: 3, text: "", image: null, imageKey: "" }, { id: 4, text: "", image: null, imageKey: "" }],
                correctAnswer: [],
                type: 'single',
                imageData: null
            });
        }
    }, [contentObj]);
    

    const handleOnChange = (e,index) => {
      
        const isCorrect = msq.correctAnswer.some((item) => item.value === index + 1 && item.checked);
      
        if (isCorrect && e.target.checked) {
          toast.success("Correct answer !!");
        } else {
          toast.error("Incorrect answer !!");
        }
      };

      console.log(contentObj,"contentObject")
      
    return (
        <>
            {msq &&
                <div className='text-xs grid grid-cols-2 gap-4 items-start'>


                    {

                        msq.type === 'single' ? (
                            msq.options.map((option, optionIndex) => {

                                return (
                                    <div key={`${contentObj.id}-${optionIndex}`} className="flex flex-col">
                                        <div className="flex gap-2 border border-solid h-10 border-gray-300 items-center px-0 py-0" key={optionIndex} >
                                            <span className="flex items-center py-2 px-3 border-r border-solid border-gray-300 h-full text-sm text-[#4F4F4F]" >{`${String.fromCharCode(65 + optionIndex)})`}</span>
                                            <input className="text-xl" type="radio" name={`${contentObj.id}-radio`} onChange={(e)=>handleOnChange(e,optionIndex)} />
                                            <div className="grow outline-none text-xs" type="text" title={option.text}>{option.text}</div>

                                        </div>
                                        {option?.image &&
                                            <div className="border border-solid h-24 mt-4 w-24 border-gray-200">
                                                <img
                                                    src={option?.image ? option?.image : null}
                                                    className={`${option?.image ? "w-28 h-full object-contain p-[2px]" : ""}`}
                                                />
                                            </div>
                                        }
                                    </div>


                                )
                            })
                        ) : (
                            msq.type === 'multiple' ? (
                                contentObj.data.options.map((option, optionIndex) => {
                                    return (
                                        <div key={`${contentObj.id}-${optionIndex}`} className="flex flex-col">
                                            <div className="flex gap-1 border border-solid h-10 border-gray-300 items-center px-0 py-0 " key={optionIndex} >
                                                <span className="flex items-center py-2 px-3 border-r border-solid border-gray-300 h-full text-sm text-[#4F4F4F]">{`${String.fromCharCode(65 + optionIndex)})`}</span>
                                                <input className="text-xl" type="checkbox" name={`${contentObj.id}-radio`} onChange={(e)=>handleOnChange(e,optionIndex)} />
                                                <div className="grow outline-none text-xs" type="text" title={option.text} >{option.text}</div>
                                            </div>
                                            {option?.image &&
                                                <div className="border border-solid mt-4 h-24 w-24 border-gray-200">
                                                    <img
                                                        src={option?.image ? option?.image : null}
                                                        className={`${option?.image ? "w-28 h-full object-contain p-[2px]" : ""}`}
                                                    />
                                                </div>
                                            }

                                        </div>
                                    )
                                }
                                )
                            ) : (
                                null
                                // return component for audio 
                            )
                        )
                    }
                </div>
            }
        </>
    )
}
